// extracted by mini-css-extract-plugin
module.exports = {"modal":"SummaryProductEditionModal_modal__3eDs3"};